import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { actionHistory } from '../../../store';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Snared extends Modifier {
  static readonly baseTitle = 'Snared';
  static readonly baseText =
    'Removes & Prevents dodge stacks. On being attacked, consume all stacks and do +25% damage for each stack.';
  static readonly baseIcon = 'web';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Snared.baseTitle;
  text = Snared.baseText;
  icon = Snared.baseIcon;
  tags: Array<ModifierTags> = [...Snared.baseTags];
  priority = Snared.basePriority;

  modifierAdd(type: StatusEffect, stacks: number) {
    if (type === StatusEffect.Dodge) {
      let difference = this.stacks - stacks;
      this.removeStacks(Math.min(this.stacks, stacks));

      if (difference >= 0) {
        stacks = 0;
      } else {
        stacks = Math.abs(difference);
      }
    }
    return stacks;
  }

  damageIn(damage: Damage) {
    damage.value = Math.ceil(damage.value * (1 + this.stacks * 0.25));
    this.removeStacks(this.stacks);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Snared, Snared);
